import type { GetOrderDetail200Order } from './getOrderDetail200Order';

export type GetOrderDetail200 = {
  message?: string;
  order?: GetOrderDetail200Order;
  success: boolean;
};
